import {FilterPredicate} from '@app/core/model/filtering/filter-predicate';

export class PredicateModel {
    public title: string;

    static isEqual(a: PredicateModel, b: PredicateModel): boolean {
        return a && b && (
            (a.title === b.title)
            && (a.name === b.name)
            && (a.isSupportMultipleArgument === b.isSupportMultipleArgument)
            && (a.isRequireArguments === b.isRequireArguments)
        );
    }

    constructor(
        public name: FilterPredicate,
        public isSupportMultipleArgument: boolean,
        public isRequireArguments: boolean
    ) {
    }

    equals(predicate: PredicateModel): boolean {
        return PredicateModel.isEqual(this, predicate);
    }
}
